import axios from 'axios';
import moment from 'moment';
import { getField, updateField } from 'vuex-map-fields';

export default {
  namespaced: true,
  state: {
    prePositionsData: [],
    prescriberRegistrationDetails: {
      agbCode: null,
      bigCode: null,
      agbOrBigCode: null,
      institutionAgb: null,
      kpNumber: null,
      newsletterSubscription: false,
      userType: false,
      titleId: 1,
      initials: '',
      firstName: '',
      prePosition: '',
      prePositionCode: '',
      lastName: '',
      maidenName: '',
      gender: '',
      dateOfBirth: '',
      phoneNumber: '',
      mobileNumber: '',
      email: '',
      treatmentAreas: [
        { treatmentAreaId: '0001', treatmentArea: 'Diabetes', active: false },
        { treatmentAreaId: '1010', treatmentArea: 'Huisartsenpraktijk', active: false },
        { treatmentAreaId: '1002', treatmentArea: 'Incontinentie', active: false },
        { treatmentAreaId: '1003', treatmentArea: 'Infuus', active: false },
        { treatmentAreaId: '1004', treatmentArea: 'Luchtwegzorg', active: false },
        { treatmentAreaId: '1005', treatmentArea: 'Stoma', active: false },
        { treatmentAreaId: '1006', treatmentArea: 'Voeding', active: false },
        { treatmentAreaId: '1007', treatmentArea: 'Wond', active: false }
      ],
      institutions: [
        {
          name: '',
          agbCode: '',
          departments: [
            {
              name: '',
              email: '',
              depotNumber: '',
              prescriberTitleId: 1,
              prescriberInitials: '',
              prescriberFirstName: '',
              prescriberPrePosition: '',
              prescriberLastName: '',
              prescriberEmail: '',
              prescriberPhoneNumber: '',
              prescriberBigCode: '',
              prescriberExternalId: '',
              validated: false,
              showWarranterDetails: false,
              showSearchWarranterDetails: false,
              isAnswered: false,
              warranterSuccessMessage: false
            }
          ],
          postalCode: '',
          houseNumber: '',
          houseNumberAddition: '',
          streetName: '',
          city: '',
          country: 'NL',
          phoneNumber: '',
          show: true,
          validated: false
        }
      ],
      userName: '',
      signature: '',
      gpRoles: [
        { roleId: 67, role: 'Anesthesist', active: false },
        { roleId: 68, role: 'Assitent verloskundige', active: false },
        { roleId: 4, role: 'Apotheker', active: false },
        { roleId: 5, role: 'Apothekersassistent', active: false },
        { roleId: 6, role: 'Arts/Specialist', active: false },
        { roleId: 8, role: 'Bandagist', active: false },
        { roleId: 69, role: 'Cardioloog', active: false },
        { roleId: 70, role: 'Chirurg', active: false },
        { roleId: 71, role: 'Dermatoloog', active: false },
        { roleId: 18, role: 'Diëtist', active: false },
        { roleId: 20, role: 'Doktersassistente', active: false },
        { roleId: 22, role: 'Ergotherapeut', active: false },
        { roleId: 24, role: 'Farmaceutisch manager', active: false },
        { roleId: 26, role: 'Fysiotherapeut', active: false },
        { roleId: 28, role: 'Gipskamerassistent', active: false },
        { roleId: 29, role: 'Gipsverbandmeester', active: false },
        { roleId: 72, role: 'Gynaecoloog', active: false },
        { roleId: 31, role: 'Huisarts', active: false },
        { roleId: 32, role: 'Hygiënist', active: false },
        { roleId: 34, role: 'Intensivist', active: false },
        { roleId: 73, role: 'Internist', active: false },
        { roleId: 74, role: 'Kinderarts', active: false },
        { roleId: 75, role: 'Klinisch Fysicus', active: false },
        { roleId: 11, role: 'Kwaliteitsverpleegkundige', active: false },
        { roleId: 38, role: 'Laborant', active: false },
        { roleId: 83, role: 'Longarts', active: false },
        { roleId: 41, role: 'Materiaaldeskundige', active: false },
        { roleId: 43, role: 'Medewerker Inco', active: false },
        { roleId: 3, role: 'Medisch specialisten', active: false },
        { roleId: 44, role: 'Medisch Technicus', active: false },
        { roleId: 84, role: 'Neuroloog', active: false },
        { roleId: 45, role: 'Nurse Practitioner', active: false },
        { roleId: 47, role: 'Operatie assistent', active: false },
        { roleId: 49, role: 'Orthopedisch IM', active: false },
        { roleId: 50, role: 'Ortoptist', active: false },
        { roleId: 77, role: 'Ortoptist', active: false },
        { roleId: 46, role: 'Overig', active: false },
        { roleId: 51, role: 'Pedicure', active: false },
        { roleId: 52, role: 'Podotherapeut', active: false },
        { roleId: 53, role: 'Praktijkondersteuner', active: false },
        { roleId: 54, role: 'Praktijkverpleegkundige', active: false },
        { roleId: 79, role: 'Specialiste ouderengeneeskunde', active: false },
        { roleId: 60, role: 'Teamleider', active: false },
        { roleId: 81, role: 'Uroloog', active: false },
        { roleId: 82, role: 'Verloskundige', active: false },
        { roleId: 61, role: 'Verpleeghuisarts', active: false },
        { roleId: 62, role: 'Verpleegkundige', active: false },
        { roleId: 63, role: 'Verzorgende', active: false },
        { roleId: 66, role: 'Zorgmanager', active: false }
      ],
      showRoleSelection: false,
      practice: [
        {
          name: '',
          agbCode: '',
          departments: [
            {
              name: '',
              email: '',
              depotNumber: '',
              prescriberTitleId: 1,
              prescriberInitials: '',
              prescriberFirstName: '',
              prescriberPrePosition: '',
              prescriberLastName: '',
              prescriberEmail: '',
              prescriberPhoneNumber: '',
              prescriberBigCode: '',
              prescriberExternalId: '',
              validated: false,
              showWarranterDetails: false,
              showSearchWarranterDetails: false,
              isAnswered: false,
              warranterSuccessMessage: false
            }
          ],
          locations: [
            {
              locationName: '',
              locationEmail: '',
              validated: false
            }
          ],
          postalCode: '',
          houseNumber: '',
          houseNumberAddition: '',
          streetName: '',
          city: '',
          country: 'NL',
          phoneNumber: '',
          show: true,
          validated: false
        }
      ]
    },
    prescriberRegistrationSteps: [
      {
        id: 0,
        title: 'Stap 1.',
        description: 'AGB/BIG/KP-code',
        show: true,
        active: true
      },
      {
        id: 1,
        title: 'Stap 2.',
        description: 'Uw (zakelijke) gegevens',
        show: false,
        active: false
      },
      {
        id: 3,
        title: 'Stap 3.',
        description: 'Specialisatie',
        show: false,
        active: false
      },
      {
        id: 4,
        title: 'Stap 4.',
        description: 'Werkgever',
        show: false,
        active: false
      },
      {
        id: 5,
        title: 'Stap 5.',
        description: 'Handtekening en inloggegevens',
        show: false,
        active: false
      },
      {
        id: 6,
        title: 'Stap 6.',
        description: 'Gegevens controleren',
        show: false,
        active: false
      }
    ],
    uploadedFileName: null,
    imagePreview: null,
    signature: [],
    registrationTexts: '',
    colleagueRegistrationTexts: '',
    registrationSuccess: false,
    warranterSuccessMessage: null,
    registrationType: null
  },
  mutations: {
    resetPresciberRegistrationDetails(state) {
      state.prescriberRegistrationDetails = {
        bigCode: '',
        kpNumber: '',
        userType: false,
        titleId: 1,
        initials: '',
        firstName: '',
        prePosition: '',
        prePositionCode: '',
        lastName: '',
        maidenName: '',
        dateOfBirth: '',
        gender: '',
        phoneNumber: '',
        mobileNumber: '',
        email: '',
        treatmentAreas: [
          { treatmentAreaId: '0001', treatmentArea: 'Diabetes', active: false },
          { treatmentAreaId: '1010', treatmentArea: 'Huisartsenpraktijk', active: false },
          { treatmentAreaId: '1002', treatmentArea: 'Incontinentie', active: false },
          { treatmentAreaId: '1003', treatmentArea: 'Infuus', active: false },
          { treatmentAreaId: '1004', treatmentArea: 'Luchtwegzorg', active: false },
          { treatmentAreaId: '1005', treatmentArea: 'Stoma', active: false },
          { treatmentAreaId: '1006', treatmentArea: 'Voeding', active: false },
          { treatmentAreaId: '1007', treatmentArea: 'Wond', active: false }
        ],
        institutions: [
          {
            name: '',
            agbCode: '',
            departments: [
              {
                name: '',
                email: '',
                depotNumber: '',
                prescriberTitleId: 1,
                prescriberInitials: '',
                prescriberFirstName: '',
                prescriberPrePosition: '',
                prescriberLastName: '',
                prescriberEmail: '',
                prescriberPhoneNumber: '',
                prescriberBigCode: '',
                prescriberExternalId: '',
                validated: false,
                showWarranterDetails: false,
                showSearchWarranterDetails: false,
                isAnswered: false,
                warranterSuccessMessage: false
              }
            ],
            postalCode: '',
            houseNumber: '',
            houseNumberAddition: '',
            streetName: '',
            city: '',
            country: 'NL',
            phoneNumber: '',
            show: true,
            validated: false
          }
        ],
        userName: '',
        signature: '',
        gpRoles: [
          { roleId: 67, role: 'Anesthesist', active: false },
          { roleId: 68, role: 'Assitent verloskundige', active: false },
          { roleId: 4, role: 'Apotheker', active: false },
          { roleId: 5, role: 'Apothekersassistent', active: false },
          { roleId: 6, role: 'Arts/Specialist', active: false },
          { roleId: 8, role: 'Bandagist', active: false },
          { roleId: 69, role: 'Cardioloog', active: false },
          { roleId: 70, role: 'Chirurg', active: false },
          { roleId: 71, role: 'Dermatoloog', active: false },
          { roleId: 18, role: 'Diëtist', active: false },
          { roleId: 20, role: 'Doktersassistente', active: false },
          { roleId: 22, role: 'Ergotherapeut', active: false },
          { roleId: 24, role: 'Farmaceutisch manager', active: false },
          { roleId: 26, role: 'Fysiotherapeut', active: false },
          { roleId: 28, role: 'Gipskamerassistent', active: false },
          { roleId: 29, role: 'Gipsverbandmeester', active: false },
          { roleId: 72, role: 'Gynaecoloog', active: false },
          { roleId: 31, role: 'Huisarts', active: false },
          { roleId: 32, role: 'Hygiënist', active: false },
          { roleId: 34, role: 'Intensivist', active: false },
          { roleId: 73, role: 'Internist', active: false },
          { roleId: 74, role: 'Kinderarts', active: false },
          { roleId: 75, role: 'Klinisch Fysicus', active: false },
          { roleId: 11, role: 'Kwaliteitsverpleegkundige', active: false },
          { roleId: 38, role: 'Laborant', active: false },
          { roleId: 83, role: 'Longarts', active: false },
          { roleId: 41, role: 'Materiaaldeskundige', active: false },
          { roleId: 43, role: 'Medewerker Inco', active: false },
          { roleId: 3, role: 'Medisch specialisten', active: false },
          { roleId: 44, role: 'Medisch Technicus', active: false },
          { roleId: 84, role: 'Neuroloog', active: false },
          { roleId: 45, role: 'Nurse Practitioner', active: false },
          { roleId: 47, role: 'Operatie assistent', active: false },
          { roleId: 49, role: 'Orthopedisch IM', active: false },
          { roleId: 50, role: 'Ortoptist', active: false },
          { roleId: 77, role: 'Ortoptist', active: false },
          { roleId: 46, role: 'Overig', active: false },
          { roleId: 51, role: 'Pedicure', active: false },
          { roleId: 52, role: 'Podotherapeut', active: false },
          { roleId: 53, role: 'Praktijkondersteuner', active: false },
          { roleId: 54, role: 'Praktijkverpleegkundige', active: false },
          { roleId: 79, role: 'Specialiste ouderengeneeskunde', active: false },
          { roleId: 60, role: 'Teamleider', active: false },
          { roleId: 81, role: 'Uroloog', active: false },
          { roleId: 82, role: 'Verloskundige', active: false },
          { roleId: 61, role: 'Verpleeghuisarts', active: false },
          { roleId: 62, role: 'Verpleegkundige', active: false },
          { roleId: 63, role: 'Verzorgende', active: false },
          { roleId: 66, role: 'Zorgmanager', active: false }
        ],
        showRoleSelection: false,
        practice: [
          {
            name: '',
            agbCode: '',
            departments: [
              {
                name: '',
                email: '',
                depotNumber: '',
                prescriberTitleId: 1,
                prescriberInitials: '',
                prescriberFirstName: '',
                prescriberPrePosition: '',
                prescriberLastName: '',
                prescriberEmail: '',
                prescriberPhoneNumber: '',
                prescriberBigCode: '',
                prescriberExternalId: '',
                validated: false,
                showWarranterDetails: false,
                showSearchWarranterDetails: false,
                isAnswered: false,
                warranterSuccessMessage: false
              }
            ],
            locations: [
              {
                locationName: '',
                locationEmail: '',
                validated: false
              }
            ],
            postalCode: '',
            houseNumber: '',
            houseNumberAddition: '',
            streetName: '',
            city: '',
            country: 'NL',
            phoneNumber: '',
            show: true,
            validated: false
          }
        ]
      };
    },
    setPreviousStepActive(state) {
      const currentActiveIndex = state.prescriberRegistrationSteps.findIndex((step) => step.show);
      state.prescriberRegistrationSteps.forEach((step) => {
        step.show = false;
        if (step.id < currentActiveIndex) {
          step.active = true;
        } else {
          step.active = false;
        }
      });
      state.prescriberRegistrationSteps[currentActiveIndex - 1].show = true;
      state.prescriberRegistrationSteps[currentActiveIndex - 1].active = true;
    },
    setNextStepActive(state) {
      const currentActiveIndex = state.prescriberRegistrationSteps.findIndex((step) => step.show);
      state.prescriberRegistrationSteps.forEach((step) => {
        step.show = false;
        if (step.id <= currentActiveIndex) {
          step.active = true;
        }
      });
      state.prescriberRegistrationSteps[currentActiveIndex + 1].show = true;
      state.prescriberRegistrationSteps[currentActiveIndex + 1].active = true;
    },
    setPrescriberRegistrationDetails(state, payload) {
      state.prescriberRegistrationDetails[payload.key] = payload.value;
    },
    setPrescriberTreatmentArea(state, payload) {
      // for gp portal disable another treatment areas
      if (payload.id == '1010') {
          state.prescriberRegistrationDetails.treatmentAreas?.forEach((item) => {
          item.active = item.treatmentAreaId === '1010';
        });
      } else {
        const currentTreatmentIndex = state.prescriberRegistrationDetails.treatmentAreas.findIndex(
          (treatmentArea) => treatmentArea.treatmentAreaId === payload.id
        );
        state.prescriberRegistrationDetails.treatmentAreas[currentTreatmentIndex].active = payload.active;
      }
    },
    setRoles(state, payload) {
      state.prescriberRegistrationDetails.gpRoles.forEach((role) => {
        if (role.roleId === payload.id) {
          role.active = true;
        } else {
          role.active = false;
        }
      });
    },
    clearPrescriberTreatmentAreas(state) {
      state.prescriberRegistrationDetails.treatmentAreas.forEach((treatmentArea) => {
        treatmentArea.active = false;
      });
    },
    saveSignature(state, payload) {
      state.signature.push(payload);
    },
    deleteSignature(state, payload) {
      state.signature = payload;
    },
    setUploadedFileName(state, payload) {
      state.uploadedFileName = payload;
    },
    setPrescriberRegistrationInstitutionDetails(state, payload) {
      state.prescriberRegistrationDetails.institutions[0] = payload;
    },
    setPrescriberRegistrationPracticeDetails(state, payload) {
      state.prescriberRegistrationDetails.practice[payload.id][payload.details.key] = payload.details.value;
    },
    addPracticeDetails(state) {
      const defaultPracticeDetails = {
        name: '',
        agbCode: '',
        departments: [
          {
            name: '',
            email: '',
            depotNumber: '',
            prescriberTitleId: 1,
            prescriberInitials: '',
            prescriberFirstName: '',
            prescriberPrePosition: '',
            prescriberLastName: '',
            prescriberEmail: '',
            prescriberPhoneNumber: '',
            prescriberBigCode: '',
            prescriberExternalId: '',
            validated: false,
            showWarranterDetails: false,
            showSearchWarranterDetails: false,
            isAnswered: false,
            warranterSuccessMessage: false
          }
        ],
        locations: [
          {
            locationName: '',
            locationEmail: '',
            validated: false
          }
        ],
        postalCode: '',
        houseNumber: '',
        houseNumberAddition: '',
        streetName: '',
        city: '',
        country: 'NL',
        phoneNumber: '',
        show: false,
        validated: false
      };

      state.prescriberRegistrationDetails.practice.push(defaultPracticeDetails);
    },
    addInstitutionDetails(state, payload) {
      let address = payload.InstitutionAddress;
      if (state.prescriberRegistrationDetails.institutions[0]) {
        state.prescriberRegistrationDetails.institutions[0].name = payload.Name;
        state.prescriberRegistrationDetails.institutions[0].agbCode = payload.AgbCode;
        if (address) {
          state.prescriberRegistrationDetails.institutions[0].postalCode = address.PostalCode;
          state.prescriberRegistrationDetails.institutions[0].houseNumber = address.HouseNumber;
          state.prescriberRegistrationDetails.institutions[0].houseNumberAddition = address.HouseNumberAddition;
          state.prescriberRegistrationDetails.institutions[0].streetName = address.StreetName;
          state.prescriberRegistrationDetails.institutions[0].city = address.City;
          state.prescriberRegistrationDetails.institutions[0].country = 'NL';
          state.prescriberRegistrationDetails.institutions[0].phoneNumber = address.PhoneNumber;
          state.prescriberRegistrationDetails.institutions[0].email = address.Email;
        }
        state.prescriberRegistrationDetails.institutions[0].show = false;
        state.prescriberRegistrationDetails.institutions[0].validated = false;
      }
    },
    addDepartmentDetails(state, payload) {
      if (state.prescriberRegistrationDetails.institutions[0].departments[0]) {
        if (payload.Name) {
          state.prescriberRegistrationDetails.institutions[0].departments[0].name = payload.Name;
        }
        state.prescriberRegistrationDetails.institutions[0].departments[0].email = payload.Email;
      }
    },
    deletePracticeDetails(state, payload) {
      state.prescriberRegistrationDetails.practice.splice(payload, 1);
      if (payload === 0) {
        state.prescriberRegistrationDetails.practice[payload].show = true;
        return;
      }
      const currentActiveIndex = state.prescriberRegistrationDetails.practice.findIndex((step) => step.show);
      if (currentActiveIndex < 0) {
        state.prescriberRegistrationDetails.practice[payload - 1].show = true;
      }
    },
    deleteInstitutionDetails(state, payload) {
      state.prescriberRegistrationDetails.institutions.splice(payload, 1);
      if (payload === 0) {
        state.prescriberRegistrationDetails.institutions[payload].show = true;
        return;
      }
      const currentActiveIndex = state.prescriberRegistrationDetails.institutions.findIndex((step) => step.show);
      if (currentActiveIndex < 0) {
        state.prescriberRegistrationDetails.institutions[payload - 1].show = true;
      }
    },
    setPracticeActive(state, payload) {
      state.prescriberRegistrationDetails.practice.forEach((step, index) => {
        step.show = false;
        if (index === payload) {
          step.show = true;
        }
      });
    },
    setInstitutionActive(state, payload) {
      state.prescriberRegistrationDetails.institutions.forEach((step, index) => {
        step.show = false;
        if (index === payload) {
          step.show = true;
        }
      });
    },
    setPrescriberRegistrationDepartmentDetails(state, payload) {
      if (payload.type === 'practice') {
        state.prescriberRegistrationDetails.practice[payload.data.parentId].departments[payload.data.id][
          payload.data.details.key
        ] = payload.data.details.value;
      } else {
        state.prescriberRegistrationDetails.institutions[payload.data.parentId].departments[payload.data.id][
          payload.data.details.key
        ] = payload.data.details.value;
      }
    },
    setPrescriberRegistrationPracticeLocationDetails(state, payload) {
      state.prescriberRegistrationDetails.practice[payload.parentId].locations[payload.id][payload.details.key] =
        payload.details.value;
    },
    addLocationDetails(state, payload) {
      const defaultLocationDetails = {
        locationName: '',
        locationEmail: '',
        validated: false
      };
      state.prescriberRegistrationDetails.practice[payload].locations.push(defaultLocationDetails);
    },
    deleteDepartmentDetails(state, payload) {
      if (payload.type === 'practice') {
        state.prescriberRegistrationDetails.practice[payload.parentId].departments.splice(payload.id, 1);
      } else {
        state.prescriberRegistrationDetails.institutions[payload.parentId].departments.splice(payload.id, 1);
      }
    },
    deleteLocationDetails(state, payload) {
      state.prescriberRegistrationDetails.practice[payload.parentId].locations.splice(payload.id, 1);
    },
    setUploadedImagePreview(state, payload) {
      state.imagePreview = payload;
    },
    setUploadedImageResponse(state, payload) {
      state.signature[0].formData = payload;
    },
    setPrescriberRegistrationTexts(state, payload) {
      state.registrationTexts = payload;
    },
    setColleagueRegistrationTexts(state, payload) {
      state.colleagueRegistrationTexts = payload;
    },
    setcolleagueRegistrationDetails(state, payload) {
      state.prescriberRegistrationDetails = payload;
    },
    setRegistrationSuccessStatus(state, payload) {
      state.registrationSuccess = payload;
    },
    setWarranterSuccessMessage(state, payload) {
      state.warranterSuccessMessage = payload;
    },
    setPrescriberData(state, payload) {
      state.prescriberRegistrationDetails.initials = payload.Initials;
      state.prescriberRegistrationDetails.firstName = payload.FirstName;
      state.prescriberRegistrationDetails.prePosition = payload.PrePosition;
      state.prescriberRegistrationDetails.lastName = payload.LastName;
      state.prescriberRegistrationDetails.maidenName = payload.MaidenName;
      state.prescriberRegistrationDetails.phoneNumber = payload.PhoneNumber;
      state.prescriberRegistrationDetails.mobileNumber = payload.MobileNumber;
      state.prescriberRegistrationDetails.email = payload.Email;
      state.prescriberRegistrationDetails.gender = payload.Gender;
      state.prescriberRegistrationDetails.dateOfBirth = payload.DateOfBirth;
      state.prescriberRegistrationDetails.prePositionCode = payload.PrePositionCode;
    },
    setPrePositions(state, payload) {
      state.prePositionsData = payload;
    },
    resetPrescriberData(state) {
      const resetKeys = [
        'initials',
        'firstName',
        'prePosition',
        'lastName',
        'maidenName',
        'phoneNumber',
        'mobileNumber',
        'email'
      ];
      resetKeys.forEach((key) => {
        state.prescriberRegistrationDetails[key] = '';
      });
    },
    updatePrescriberData(state, field) {
      state.prescriberRegistrationDetails[field.key] = field.value;
    },
    updateDepartmentData(state, field) {
      updateField(state.prescriberRegistrationDetails.institutions[0].departments[0], field);
    },
    setShowRoleSelection(state, payload) {
      state.prescriberRegistrationDetails.showRoleSelection = payload;
    }
  },
  actions: {
    savePrescriberRegistration({ state, commit }) {
      let userType = 1;
      
      if (state.prescriberRegistrationDetails.email) {
        state.prescriberRegistrationDetails.username = state.prescriberRegistrationDetails.email;
      }
      if (
        state.prescriberRegistrationDetails.dateOfBirth &&
        state.prescriberRegistrationDetails.dateOfBirth.indexOf('-') === 2
      ) {
        state.prescriberRegistrationDetails.dateOfBirth = moment(
          state.prescriberRegistrationDetails.dateOfBirth,
          'DD-MM-YYYY'
        ).format('YYYY-MM-DD');
      }
      state.prescriberRegistrationDetails.userType = userType;
      const treatmentIndex = state.prescriberRegistrationDetails.treatmentAreas.findIndex(
        (treatmentArea) => treatmentArea.treatmentAreaId === '1010'
      );
      state.prescriberRegistrationDetails.registrationType = 1;
      let computedDetails = state.prescriberRegistrationDetails;
      if (state.prescriberRegistrationDetails.treatmentAreas[treatmentIndex].active) {
        state.prescriberRegistrationDetails.treatmentAreas.forEach((area) => {
          area.active = true;
        });
        // if trearmentarea is 1010 then we have practice
        computedDetails.practice = state.prescriberRegistrationDetails.institutions
        if(computedDetails.practice) {
        computedDetails.practice.forEach((practice) => {
          delete practice.locations;
          practice.locations = practice.departments;
          delete practice.departments;
        });
        computedDetails.institutions = null;
        }
      } else {
        computedDetails.practice = null;
      }
      return axios
        .post('Registration/RegisterPrescriber', computedDetails)
        .then((response) => {
          if (response && response.data && response.data.Success) {
            return response.data;
          }
          return response.data;
        })
        .catch(() => {
          if (state.prescriberRegistrationDetails.dateOfBirth.indexOf('-') === 4) {
            state.prescriberRegistrationDetails.dateOfBirth = moment(
              state.prescriberRegistrationDetails.dateOfBirth,
              'YYYY-MM-DD'
            ).format('DD-MM-YYYY');
          }
        });
    },
    saveColleagueRegistration({ state, commit }) {
      state.prescriberRegistrationDetails.registrationType = 2;
      let userType = 1;
      if (state.prescriberRegistrationDetails.userType) {
        userType = 2;
      }
      state.prescriberRegistrationDetails.userType = userType;

      let dateOfBirth = state.prescriberRegistrationDetails.dateOfBirth;
      if (dateOfBirth && dateOfBirth.indexOf('-') === 2) {
        state.prescriberRegistrationDetails.dateOfBirth = moment(
          state.prescriberRegistrationDetails.dateOfBirth,
          'DD-MM-YYYY'
        ).format('YYYY-MM-DD');
      }

      return axios.post('Registration/RegisterColleague', state.prescriberRegistrationDetails).then((response) => {
        if (response && response.data) {
          commit('setRegistrationSuccessStatus', true);
        }
      });
    },
    saveUploadedFile({ state, commit }) {
      return axios.post('Registration/SignatureUpload', state.signature[0].formData).then((response) => {
        commit('setUploadedImageResponse', response.data);
      });
    },
    fetchRegistrationTexts({ commit }) {
      axios.get('Registration/RegistrationSitecoreTexts').then((response) => {
        if (response && response.data && response.data.Success) {
          commit('setPrescriberRegistrationTexts', response.data.RegistrationTexts);
        }
      });
    },
    fetchPrePositions({ commit }) {
      axios.get('Registration/GetPrePositions').then((response) => {
        if (response && response) {
          commit('setPrePositions', response.data);
        }
      });
    },
    fetchPrescriberAccountDataUsingCode({ state, commit }, details) {
      let api =
        'Registration/UserLookUpWithAgbOrBig?lookUpPharse=' +
        details.code +
        '&lookUpPharseType=' +
        details.lookUpPharseType;
      return axios.get(api).then((response) => {
        if (
          response &&
          response.data &&
          response.data.data &&
          response.data.Success &&
          response.data.data.AllowRegistration
        ) {
          if (response.data.data) {
            commit('setPrescriberData', response.data.data);
          }
        } else {
          commit('resetPrescriberData');
        }
        return response.data.data;
      });
    },
    fetchInstitution({ commit }, details) {
      let api =
        'Registration/InstitutionLookUpWithAgb?lookUpPharse=' + details.code + '&lookUpType=' + details.lookUpType;
      return axios.get(api).then((response) => {
        if (response && response.data && response.data.data && response.data.Success) {
          if (response.data.data) {
            return response.data.data;
          }
        }
      });
    },
    fetchInstitutionDetail({ commit }, details) {
      let api =
        'Registration/GetInstitutionDetailWithAgb?lookUpPharse=' +
        details.code +
        '&lookUpPharseType=' +
        details.lookUpPharseType;
      return axios.get(api).then((response) => {
        if (response && response.data && response.data.data && response.data.Success) {
          if (response.data.data) {
            //commit('setPrescriberRegistrationInstitutionDetails', response.data.data);
          }
        }
        return response.data.data;
      });
    },
    fetchUserInstitutionRelation({ commit }, lookUpPharse) {
      let api = 'Registration/UserInstitutionRelationLookUpWithAgb?lookUpPharse=' + lookUpPharse;
      return axios.get(api).then((response) => {
        if (response && response.data && response.data.data && response.data.Success) {
          if (response.data.data) {
            // commit('setPrescriberRegistrationInstitutionDetails', response.data.data);
          }
        }
        return response.data.data;
      });
    },
    fetchDepartments({ commit }, lookUpPharse) {
      let api = 'Registration/DepartmentLookUpWithAgb?lookUpPharse=' + lookUpPharse;
      return axios.get(api).then((response) => {
        if (response && response.data && response.data.data && response.data.Success) {
          if (response.data.data) {
             return response.data.data;
          }
        }
      });
    },
    fetchWarranterDepartments({ commit }, lookUpPharse) {
      let api = 'Registration/GetWarranterDepartments?lookUpPharse=' + lookUpPharse;
      return axios.get(api).then((response) => {
        if (response && response.data && response.data.data && response.data.Success) {
          if (response.data.data) {
             return response.data.data;
          }
        }
      });
    },
    async isEmailAlreadyExists({ commit }, email) {
      let api = 'Registration/IsUserEmailAlreadyExists?email=' + email;
       return axios.get(api).then((response) => {
        if (response && response.data) {
          if (response.data.data) {
              return response.data.data;
          }
        }
      });
    },
  },
  getters: {
    getPrescriberRegistrationDetails: (state) => {
      return state.prescriberRegistrationDetails;
    },
    getPrePositionsRecords: (state) => {
      return state.prePositionsData;
    },
    getPrescriberRegistrationSteps: (state) => {
      return state.prescriberRegistrationSteps;
    },
    getUploadedFileName: (state) => {
      return state.uploadedFileName;
    },
    getUploadedImage: (state) => {
      return state.imagePreview;
    },
    getSignatureDetails: (state) => {
      return state.signature;
    },
    getPrescriberRegistrationTexts: (state) => {
      return state.registrationTexts;
    },
    getColleagueRegistrationTexts: (state) => {
      return state.colleagueRegistrationTexts;
    },
    getRegistrationSuccessStatus: (state) => {
      return state.registrationSuccess;
    },
    getWarranterSuccessMessage: (state) => {
      return state.warranterSuccessMessage;
    },
    getColleagueRegistrationDetails: (state) => {
      return state.prescriberRegistrationDetails;
    },
    getPrescriberData: (state) => {
      return getField(state.prescriberRegistrationDetails);
    },
    getDepartmentData: (state) => {
      return getField(state.prescriberRegistrationDetails.institutions[0].departments[0]);
    },
    getRoles: (state) => {
      return state.prescriberRegistrationDetails.gpRoles;
    }
  }
};
